import React, {
    useState,
    forwardRef,
    useImperativeHandle,
    useEffect,
    useRef
} from 'react'
import { nanoid } from 'nanoid'
import cn from 'classnames'

import st from './index.scss'

/**
 * 
 * 弹幕组件
 *
 * @param { number } maxBarrageHeight 弹幕最大高度是多少（这个是为了方便计算弹幕出现的位置，如果写小了，弹幕可能会出现在看不到的地方，或只出现一半）
 * @param { number } duration 弹幕移动的时间（单位：秒)
 * @param { number } paddingTop 弹幕区域上端需要保留的距离 （为了弹幕左右图案不超出弹幕区域，导致弹幕显示不全）
 * 
 * @current { func } setBarrageItem 插入一个弹幕元素，传入一个组件即可
 */
export default forwardRef(function Barrage(
    { className, maxBarrageHeight = 0, duration = 5, paddingTop = 0, ...props },
    ref
) {
    const box_ref = useRef(null)
    const [bar, setBar] = useState(new Map())
    const [height, setHeight] = useState(0)

    useImperativeHandle(ref, () => ({
        // 外部调用此方法直接显示错误 如果传入参数 则按参数显示错误信息
        setBarrageItem: (component) => {
            const id = nanoid()
            bar.set(id, {
                top: Math.random() * (height - maxBarrageHeight) + paddingTop,
                component
            })
            // 动画播完了就移除
            setTimeout(
                () =>
                    setBar((bb) => {
                        bb.delete(id)
                        return new Map(bb)
                    }),
                duration * 1000 * 1.5
            )
            return setBar(new Map(bar))
        }
    }))

    useEffect(() => {
        setHeight(box_ref.current.offsetHeight)
    })

    return (
        <div className={cn(st['box'], className)} {...props} ref={box_ref}>
            {[...bar.keys()].map((key) => {
                const item = bar.get(key)
                return (
                    <div
                        className={st['bar']}
                        key={key}
                        style={{
                            top: item.top,
                            animationDuration: `${duration * 2}s`,
                        }}
                    >
                        {item.component}
                    </div>
                )
            })}
        </div>
    )
})
